import cx from 'classnames'
import * as React from 'react'
import {CSSProperties} from "react";

import type { LinkViewModel } from '../../view-models/LinkViewModel'
import Link from '../Link/Link'
import styles from './dropdownLinks-style.css'

type Props = {
  items?: Array<LinkViewModel>
  position?: string
  className?: string
  eventName?: string
}
type State = {}

class DropdownLinks extends React.Component<Props, State> {
  static displayName = 'DropdownLinks'
  static defaultProps = {}

  get styles(): CSSProperties {
    const { position } = this.props

    if (position === 'right') {
      return {
        left: 'auto',
        right: 0,
        textAlign: 'right',
      }
    } else if (position === 'center') {
      return {
        left: '50%',
        transform: 'translateX(-50%)',
      }
    } else {
      return {
        right: 0,
      }
    }
  }

  renderItem = (item: LinkViewModel) => {
    const eventMeta =
      this.props.eventName === 'login'
        ? {
            event: 'login',
            eventData: item.label,
          }
        : {}

    return (
      <li key={item.href} className={styles.item}>
        <Link
          {...item}
          noUnderline
          className={cx(styles.itemLink, {
            [styles.itemLinkActive]: item.active,
          })}
        >
          {item.label}
        </Link>
      </li>
    )
  }

  render() {
    const { items, className } = this.props

    if (!items) {
      return null
    }

    return (
      <ul className={cx(styles.dropdownLinks, className && className)} style={this.styles}>
        {items.map(this.renderItem)}
      </ul>
    )
  }
}

export default DropdownLinks